import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const Style = styled.div`
  margin-left: 20px;
  flex: 1;
  display: flex;
  justify-content: space-between;

  .legend-risk {
    display: flex;
    gap: 2px;

    .circle-cont {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .circle {
        background: #DBDBDB;
        border-radius: 100%;
      }
    }

    label {
      margin-bottom: 0px;
      font-size: 14px;
      color: #595959;
      font-weight: 500;
      margin-left: 10px;
    }
  }

  .icon-cont {
    svg {
      color: #DDDDDD;
      width: 18px;
      height: 18px;
      margin-top: -7px;
    }
  }
`;

const Header = ({
  tooltip,
  legend = false,
  t = (s) => s,
}) => {
  const legendRendered = useMemo(() => {
    if (legend === 'RISK_MATERIALISATION') {
      return (
        <div className="legend-risk">
          {[4, 8, 10, 12].map((i) => (
            <div className="circle-cont" key={`circles-size-${i}`}>
              <div className="circle" style={{ width: i, height: i }} />
            </div>
          ))}
          <label>{t('Number of incidents')}</label>
        </div>
      )
    }
    return null
  }, [legend, t]);

  return (
    <Style>
      <div className="icon-cont">
        {!!tooltip ? (
          <Tooltip title={tooltip}>
            <InfoCircleOutlined />
          </Tooltip>
        ) : null}
      </div>
      {legendRendered}
    </Style>
  );
}

export default Header;
